<template>
  <div class="text-xs-center">
    <v-dialog
v-model="pages.modals.deleteSelected"
      width="500"
    >

      <v-card>


        <v-toolbar dark  color="#4A76A8" flat  height="42">
          <v-toolbar-title  > Удаление   из списка активности  </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon @click="cancel()">mdi-close</v-icon>
        </v-toolbar>


        <v-card-text scrollable>

  Вы действительно хотите удалть  {{pages.selected.length}}   из списка активности? отменить данное
  действие будет невозможно

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#4A76A8" small
            flat
            @click="cancel()"
          >
            Отмена
          </v-btn>
          <v-btn
            color="red" small class="white--text"
            @click="ok()"
          >
            Удалить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>




<script>
import axios from 'axios'
export default {
props: [ 'pages'],
 data: function(){
  return {

  }
},

methods: {
 ok: function(){
   let ids = []
    this.pages.modals.deleteSelected = false
    this.pages.selected.forEach( (item,i,arr)=>{
      ids[i] =  item.vk_id
    })
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/pages/pages_delete.php', {
         method: 'POST', data: {ids:ids}
       }).then(response => {
         axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/pages/pages_get.php', {
              method: 'POST'
            }).then(response => {
        this.pages.loading = false
        this.pages.all = response.data
        this.$store.dispatch('changeCounters') 
            })
       })





 },
 cancel: function(){
   this.pages.modals.deleteSelected = false
 }

}
}
</script>

<style  >

</style>
